@if (data.isSuccess) {
    <span class="self-center" matSnackBarLabel>
        Het verplaatsen is gelukt.
    </span>
    <span matSnackBarActions>
        <button class="
                [--mdc-text-button-label-text-color:var(--color-primary-500)]
                [--mat-text-button-state-layer-color:var(--color-primary-100)]
            " mat-button matSnackBarAction (click)="undo()">
            Ongedaan maken
        </button>
    </span>
} @else {
    <span class="self-center" matSnackBarLabel>
        Het verplaatsen is niet gelukt.
    </span>
}